import { Editor } from 'slate'
import { omit } from 'ramda'
import { useEditor } from 'slate-react'
import React from 'react'

import Loading from '../../kiti/components/helpers/Loading'

const EditorContext = React.createContext({})
export const useEditorState = () => React.useContext(EditorContext)

export const useLeafMenuForm = (editor, name) => {
  const { menu } = useEditorState()
  const [form, setForm] = React.useState({})
  const handleChange = (field, value) => setForm({ ...form, [field]: value })

  React.useEffect(() => {
    if (menu !== name) return

    const marks = Editor.marks(editor)
    setForm(marks || {})
  }, [menu])

  return [form, setForm, handleChange]
}

export const useNodeMenuForm = (editor, name, parentNode) => {
  const { menu } = useEditorState()
  const [form, setForm] = React.useState({})
  const handleChange = (field, value) => setForm({ ...form, [field]: value })

  React.useEffect(() => {
    if (!menu || menu !== name) return setForm({})

    let [node] = Editor.node(editor, editor.selection)
    if (parentNode) {
      try {
        node = Editor.parent(editor, editor.selection)[0]
      } catch (e) {}
    }
    setForm(omit(['children'], node || {}))
  }, [menu])

  return [form, setForm, handleChange]
}

const EditorHandler = ({ children, size = 'normal' }) => {
  const editor = useEditor()
  const [menu, setMenu] = React.useState()
  const [loading, setLoading] = React.useState(false)

  React.useEffect(() => {
    editor.setLoading = setLoading
  }, [])

  return (
    <EditorContext.Provider value={{ menu, setMenu, size, loading, setLoading }}>
      {loading ? <Loading /> : children}
    </EditorContext.Provider>
  )
}

export default EditorHandler
